// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons[data-v-69fa0d67]{display:flex}a[data-v-69fa0d67]{margin-right:15px}a+.btn[data-v-69fa0d67]{padding-right:10px;padding-left:15px}", ""]);
// Exports
module.exports = exports;
